<template>
  <div class="">
    <div class="wrap">
      <div :class="unitType" v-for="(item, index) in seriesData" :key="index">
        <div
          :class="['group', `group${index}`, seriesData[index + 1] && seriesData[index + 1].list ? '' : 'cansol']"
          v-for="(it, index1) in item.list"
          :key="index1" @click="toRedit(it.return, item.name)"
        >
          <div class="circle" v-if="index1 == 0">
            {{ showTitle(item.game_round) }}
          </div>
          <div class="icon">
            <img src="@/assets/images/icon-bz.png" alt="">
          </div>
          <div class="contents">
            <div class="group-item bg-one">
              <div class="rank">
                {{ it.return[0] && it.return[0].num ? it.return[0].num : "" }}
              </div>
              <div class="avatar">
                <img v-if="it.return[0].cover" :src="it.return[0].cover" mode="">
                <img v-else src="@/assets/images/avatar-default.png" mode="">
              </div>
              <div class="name text-nowrap">
                {{ it.return[0] && it.return[0].nickname ? it.return[0].nickname : "" }}
                <!-- {{'cs1'}} -->
              </div>

              <div class="scores">
                <div class="score-item" v-for="(j, index2) in it.return[0].achievement" :key="index2">
                  {{ j ? j : "0" }}
                </div>
              </div>
              <!-- :class="['grade',it.return[0]&&it.return[1]&&it.return[0].division&&it.return[1].division&&it.return[0].division>it.return[1].division ? 'bg-red' : 'bg-blue']"> -->
              <div v-if="it.project && it.project.bow == 3" :class="['grade', it.return[0] && it.return[0].outcome ? 'bg-red' : 'bg-blue']">
                {{ it.return[0] && it.return[0].total ? it.return[0].total : "0" }}
              </div>
              <div v-else :class="['grade', it.return[0] && it.return[0].outcome ? 'bg-red' : 'bg-blue']">
                {{ it.return[0] && it.return[0].division ? it.return[0].division : "0" }}
              </div>
            </div>
            <div class="group-item bg-two" style="color: #6c7a85">
              <div class="rank">
                {{ it.return[1] && it.return[1].num ? it.return[1].num : "" }}
              </div>
              <div class="avatar">
                <img v-if="it.return[1].cover" :src="it.return[1].cover" mode="">
                <img v-else src="@/assets/images/avatar-default.png" mode="">
              </div>
              <div class="name text-nowrap">
                {{ it.return[1] && it.return[1].nickname ? it.return[1].nickname : "" }}
                <!-- {{'cs2'}} -->
              </div>

              <div class="scores">
                <div class="score-item" v-for="(j, index2) in it.return[1].achievement" :key="index2">
                  {{ j ? j : "0" }}
                </div>
              </div>
              <div v-if="it.project && it.project.bow == 3" :class="['grade', it.return[1] && it.return[1].outcome ? 'bg-red' : 'bg-blue']">
                {{ it.return[1] && it.return[1].total ? it.return[1].total : "0" }}
              </div>
              <div v-else :class="['grade', it.return[1] && it.return[1].outcome ? 'bg-red' : 'bg-blue']">
                {{ it.return[1] && it.return[1].division ? it.return[1].division : "0" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "elimination-series",
  props: {
    seriesData: {
      type: Array,
      default: () => {
        [];
      },
    },
    unitType: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {};
  },
  onShow() {},
  computed: {
    showTitle(e) {
      return (e) => {
        if (e == 1) {
          return "第一轮";
        } else if (e == 2) {
          return "第二轮";
        } else if (e == 3) {
          return "1/48";
        } else if (e == 4) {
          return "1/24";
        } else if (e == 5) {
          return "1/16";
        } else if (e == 6) {
          return "1/12";
        } else if (e == 7) {
          return "1/8";
        } else if (e == 8) {
          return "1/4";
        } else if (e == 9) {
          return "1/2";
        } else if (e == 10) {
          return "铜牌决赛";
        } else if (e == 11) {
          return "金牌决赛";
        } else {
          return "";
        }
      };
    },
  },
  methods: {
    toRedit(data, name) {
      console.log('11111111');
      let obj = {
        arr: data,
        name: name,
      };
      this.$emit("toRedit1", obj);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;
  padding: 32px 10px 80px;
  display: flex;
  // flex-direction: row-reverse;
  // align-items: center;
  width: 100%;
  box-sizing: border-box;
  overflow-x: scroll;
  // white-space: nowrap;

  .text-nowrap {
    max-width: 100%;
    // display: table-cell;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .bg-one {
    background-color: #f0f6f6;
  }

  .bg-two {
    background-color: #f9fafc;
  }

  .bg-blue {
    background-color: #305395;
  }

  .bg-red {
    background-color: #fe4744;
  }

  .group {
    position: relative;
    display: flex;
    height: 45px;
    width: 317px;

    .circle {
      position: absolute;
      top: -22px;
      left: 0px;
      font-size: 16px;
      text-align: left;
      width: 100px;
      height: 22px;
      line-height: 22px;
      color: #d9d9d9;
      margin-bottom: 5px;
    }

    .icon {
      width: 22px;
      height: 44px;
      background-color: #f0f6f6;
      margin-right: 1px;
      display: flex;
      justify-content: center;


      img {
        width: 16px;
        height: 18px;
        
      }
    }

    .contents {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .group-item {
        width: auto;
        height: 22px;
        display: flex;
        font-size: 14px;

        .avatar {
          width: 22px;
          height: 22px;
          margin-left: 14px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name {
          width: 50px;
          height: 22px;
          text-align: left;
          line-height: 22px;
          padding-left: 2px;
        }

        .rank {
          width: 22px;
          height: 22px;
          line-height: 22px;
          margin-left: 2px;
        }

        .scores {
          display: flex;
          text-align: left;
          min-width: 132px;

          .score-item {
            width: 22px;
            height: 22px;
            line-height: 22px;
          }
        }

        .grade {
          width: 25px;
          height: 22px;
          line-height: 22px;
          color: white;
          font-size: 14px;
          text-align: center;
        }
      }
    }
  }

  .cansol {
    // 支线
    &:nth-of-type(2n + 1)::before {
      display: none;
    }

    &:nth-of-type(2n + 1)::after {
      display: none;
    }
  }

  .unit48 {
    margin-right: 7px;
    position: relative;

    &:nth-last-child(2) {
      margin-right: 0px;
    }

    .group8 {
      margin-top: 3497px;
    }

    .group7 {
      position: absolute !important;
      top: calc(50% + 70px);
    }

    .group6 {
      margin-bottom: 3474px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 1737px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 3474px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 1738px;
      }
    }

    .group5 {
      margin-bottom: 1715px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 857.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 1715px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 857px;
      }
    }

    .group4 {
      margin-bottom: 835px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 417.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 835px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 416px;
      }
    }

    .group3 {
      margin-bottom: 395px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 197.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 395px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 195px;
      }
    }

    .group2 {
      margin-bottom: 175px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 87.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 175px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 84px;
      }
    }

    .group1 {
      margin-bottom: 65px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 32.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 65px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 28px;
      }
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }

  .unit24 {
    margin-right: 7px;
    position: relative;

    &:nth-last-of-type(2) {
      margin-right: 0px;
    }

    .group7 {
      margin-top: 1738px;
    }

    .group6 {
      position: absolute !important;
      top: calc(50% + 70px);
    }

    .group5 {
      margin-bottom: 1715px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 857.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 1715px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 857px;
      }
    }

    .group4 {
      margin-bottom: 835px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 417.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 835px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 416px;
      }
    }

    .group3 {
      margin-bottom: 395px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 197.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 395px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 195px;
      }
    }

    .group2 {
      margin-bottom: 175px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 87.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 175px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 84px;
      }
    }

    .group1 {
      margin-bottom: 65px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 32.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 65px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 28px;
      }
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }

  .unit16 {
    margin-right: 7px;
    position: relative;

    &:nth-last-of-type(2) {
      margin-right: 0px;
    }

    .group6 {
      margin-top: 857px;
    }

    .group5 {
      position: absolute !important;
      top: calc(50% + 70px);
    }

    .group4 {
      margin-bottom: 835px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 417.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 835px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 416px;
      }
    }

    .group3 {
      margin-bottom: 395px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 197.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 395px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 195px;
      }
    }

    .group2 {
      margin-bottom: 175px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 87.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 175px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 84px;
      }
    }

    .group1 {
      margin-bottom: 65px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 32.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 65px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 28px;
      }
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }

  .unit12 {
    margin-right: 7px;
    position: relative;

    &:nth-last-of-type(2) {
      margin-right: 0px;
    }

    .group5 {
      margin-top: 416px;
    }

    .group4 {
      position: absolute !important;
      top: calc(50% + 70px);
    }

    .group3 {
      margin-bottom: 395px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 197.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 395px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 195px;
      }
    }

    .group2 {
      margin-bottom: 175px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 87.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 175px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 84px;
      }
    }

    .group1 {
      margin-bottom: 65px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 32.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 65px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 28px;
      }
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }

  .unit8 {
    margin-right: 7px;
    position: relative;
    &:nth-last-of-type(2) {
      margin-right: 0px;
    }

    .group4 {
      margin-top: 195px;

    }

    .group3 {
      position: absolute !important;
      top: calc(50% + 70px);
      z-index: 99;
    }

    .group2 {
      margin-bottom: 175px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 87.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 175px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 84px;
      }
    }

    .group1 {
      margin-bottom: 65px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 32.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 65px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 28px;
      }
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }

  .unit4 {
    margin-right: 7px;
    position: relative;

    &:nth-last-of-type(2) {
      margin-right: 0px;
    }

    .group3 {
      margin-top: 95px;
    }

    .group2 {
      position: absolute !important;
      top: calc(50% + 70px);
    }

    .group1 {
      margin-bottom: 65px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 32.5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 65px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }

      &:nth-of-type(1) {
        margin-top: 28px;
      }
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }

  .unit-half {
    margin-right: 7px;
    position: relative;

    &:nth-last-of-type(2) {
      margin-right: 0px;
    }

    .group2 {
      margin-top: 28px;
    }

    .group1 {
      position: absolute !important;
      top: calc(50% + 70px);
    }

    .group0 {
      margin-bottom: 10px;

      // 支线
      &:nth-of-type(2n + 1)::before {
        width: 15px;
        height: 1px;
        position: absolute;
        border-top: 1px solid black;
        border-left: 1px solid black;
        top: calc(44px + 5px);
        right: -5px;
        content: "";
      }

      &:nth-of-type(2n + 1)::after {
        width: 15px;
        height: calc(44px + 10px);
        position: absolute;
        border-top: 1px solid black;
        border-right: 1px solid black;
        border-bottom: 1px solid black;
        top: 22px;
        right: 10.5px;
        content: "";
      }

      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
